const createUsernameFromEmail = (str: string) => {
  const newstr = str.replace(/[^a-zA-Z0-9 ]/g, '');
  return newstr;
};

export default createUsernameFromEmail;